import type { SelectFieldOption } from '@/types';

/**
 * Note: values are sourced from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
 */
const countryOptions: SelectFieldOption<string>[] = [
  { label: 'Aruba', value: 'ABW' },
  { label: 'Afghanistan', value: 'AFG' },
  { label: 'Angola', value: 'AGO' },
  { label: 'Anguilla', value: 'AIA' },
  { label: 'Åland Islands', value: 'ALA' },
  { label: 'Albania', value: 'ALB' },
  { label: 'Andorra', value: 'AND' },
  { label: 'United Arab Emirates', value: 'ARE' },
  { label: 'Argentina', value: 'ARG' },
  { label: 'Armenia', value: 'ARM' },
  { label: 'American Samoa', value: 'ASM' },
  { label: 'Antarctica', value: 'ATA' },
  { label: 'French Southern Territories', value: 'ATF' },
  { label: 'Antigua and Barbuda', value: 'ATG' },
  { label: 'Australia', value: 'AUS' },
  { label: 'Austria', value: 'AUT' },
  { label: 'Azerbaijan', value: 'AZE' },
  { label: 'Burundi', value: 'BDI' },
  { label: 'Belgium', value: 'BEL' },
  { label: 'Benin', value: 'BEN' },
  { label: 'Bonaire, Sint Eustatius and Saba', value: 'BES' },
  { label: 'Burkina Faso', value: 'BFA' },
  { label: 'Bangladesh', value: 'BGD' },
  { label: 'Bulgaria', value: 'BGR' },
  { label: 'Bahrain', value: 'BHR' },
  { label: 'Bahamas', value: 'BHS' },
  { label: 'Bosnia and Herzegovina', value: 'BIH' },
  { label: 'Saint Barthélemy', value: 'BLM' },
  { label: 'Belarus', value: 'BLR' },
  { label: 'Belize', value: 'BLZ' },
  { label: 'Bermuda', value: 'BMU' },
  { label: 'Bolivia, Plurinational State of', value: 'BOL' },
  { label: 'Brazil', value: 'BRA' },
  { label: 'Barbados', value: 'BRB' },
  { label: 'Brunei Darussalam', value: 'BRN' },
  { label: 'Bhutan', value: 'BTN' },
  { label: 'Bouvet Island', value: 'BVT' },
  { label: 'Botswana', value: 'BWA' },
  { label: 'Central African Republic', value: 'CAF' },
  { label: 'Canada', value: 'CAN' },
  { label: 'Cocos (Keeling) Islands', value: 'CCK' },
  { label: 'Switzerland', value: 'CHE' },
  { label: 'Chile', value: 'CHL' },
  { label: 'China', value: 'CHN' },
  { label: "Côte d'Ivoire", value: 'CIV' },
  { label: 'Cameroon', value: 'CMR' },
  { label: 'Congo, Democratic Republic of the', value: 'COD' },
  { label: 'Congo', value: 'COG' },
  { label: 'Cook Islands', value: 'COK' },
  { label: 'Colombia', value: 'COL' },
  { label: 'Comoros', value: 'COM' },
  { label: 'Cabo Verde', value: 'CPV' },
  { label: 'Costa Rica', value: 'CRI' },
  { label: 'Cuba', value: 'CUB' },
  { label: 'Curaçao', value: 'CUW' },
  { label: 'Christmas Island', value: 'CXR' },
  { label: 'Cayman Islands', value: 'CYM' },
  { label: 'Cyprus', value: 'CYP' },
  { label: 'Czechia', value: 'CZE' },
  { label: 'Germany', value: 'DEU' },
  { label: 'Djibouti', value: 'DJI' },
  { label: 'Dominica', value: 'DMA' },
  { label: 'Denmark', value: 'DNK' },
  { label: 'Dominican Republic', value: 'DOM' },
  { label: 'Algeria', value: 'DZA' },
  { label: 'Ecuador', value: 'ECU' },
  { label: 'Egypt', value: 'EGY' },
  { label: 'Eritrea', value: 'ERI' },
  { label: 'Western Sahara', value: 'ESH' },
  { label: 'Spain', value: 'ESP' },
  { label: 'Estonia', value: 'EST' },
  { label: 'Ethiopia', value: 'ETH' },
  { label: 'Finland', value: 'FIN' },
  { label: 'Fiji', value: 'FJI' },
  { label: 'Falkland Islands (Malvinas)', value: 'FLK' },
  { label: 'France', value: 'FRA' },
  { label: 'Faroe Islands', value: 'FRO' },
  { label: 'Micronesia, Federated States of', value: 'FSM' },
  { label: 'Gabon', value: 'GAB' },
  { label: 'United Kingdom of Great Britain and Northern Ireland', value: 'GBR' },
  { label: 'Georgia', value: 'GEO' },
  { label: 'Guernsey', value: 'GGY' },
  { label: 'Ghana', value: 'GHA' },
  { label: 'Gibraltar', value: 'GIB' },
  { label: 'Guinea', value: 'GIN' },
  { label: 'Guadeloupe', value: 'GLP' },
  { label: 'Gambia', value: 'GMB' },
  { label: 'Guinea-Bissau', value: 'GNB' },
  { label: 'Equatorial Guinea', value: 'GNQ' },
  { label: 'Greece', value: 'GRC' },
  { label: 'Grenada', value: 'GRD' },
  { label: 'Greenland', value: 'GRL' },
  { label: 'Guatemala', value: 'GTM' },
  { label: 'French Guiana', value: 'GUF' },
  { label: 'Guam', value: 'GUM' },
  { label: 'Guyana', value: 'GUY' },
  { label: 'Hong Kong', value: 'HKG' },
  { label: 'Heard Island and McDonald Islands', value: 'HMD' },
  { label: 'Honduras', value: 'HND' },
  { label: 'Croatia', value: 'HRV' },
  { label: 'Haiti', value: 'HTI' },
  { label: 'Hungary', value: 'HUN' },
  { label: 'Indonesia', value: 'IDN' },
  { label: 'Isle of Man', value: 'IMN' },
  { label: 'India', value: 'IND' },
  { label: 'British Indian Ocean Territory', value: 'IOT' },
  { label: 'Ireland', value: 'IRL' },
  { label: 'Iran, Islamic Republic of', value: 'IRN' },
  { label: 'Iraq', value: 'IRQ' },
  { label: 'Iceland', value: 'ISL' },
  { label: 'Israel', value: 'ISR' },
  { label: 'Italy', value: 'ITA' },
  { label: 'Jamaica', value: 'JAM' },
  { label: 'Jersey', value: 'JEY' },
  { label: 'Jordan', value: 'JOR' },
  { label: 'Japan', value: 'JPN' },
  { label: 'Kazakhstan', value: 'KAZ' },
  { label: 'Kenya', value: 'KEN' },
  { label: 'Kyrgyzstan', value: 'KGZ' },
  { label: 'Cambodia', value: 'KHM' },
  { label: 'Kiribati', value: 'KIR' },
  { label: 'Saint Kitts and Nevis', value: 'KNA' },
  { label: 'Korea, Republic of', value: 'KOR' },
  { label: 'Kuwait', value: 'KWT' },
  { label: "Lao People's Democratic Republic", value: 'LAO' },
  { label: 'Lebanon', value: 'LBN' },
  { label: 'Liberia', value: 'LBR' },
  { label: 'Libya', value: 'LBY' },
  { label: 'Saint Lucia', value: 'LCA' },
  { label: 'Liechtenstein', value: 'LIE' },
  { label: 'Sri Lanka', value: 'LKA' },
  { label: 'Lesotho', value: 'LSO' },
  { label: 'Lithuania', value: 'LTU' },
  { label: 'Luxembourg', value: 'LUX' },
  { label: 'Latvia', value: 'LVA' },
  { label: 'Macao', value: 'MAC' },
  { label: 'Saint Martin (French part)', value: 'MAF' },
  { label: 'Morocco', value: 'MAR' },
  { label: 'Monaco', value: 'MCO' },
  { label: 'Moldova, Republic of', value: 'MDA' },
  { label: 'Madagascar', value: 'MDG' },
  { label: 'Maldives', value: 'MDV' },
  { label: 'Mexico', value: 'MEX' },
  { label: 'Marshall Islands', value: 'MHL' },
  { label: 'North Macedonia', value: 'MKD' },
  { label: 'Mali', value: 'MLI' },
  { label: 'Malta', value: 'MLT' },
  { label: 'Myanmar', value: 'MMR' },
  { label: 'Montenegro', value: 'MNE' },
  { label: 'Mongolia', value: 'MNG' },
  { label: 'Northern Mariana Islands', value: 'MNP' },
  { label: 'Mozambique', value: 'MOZ' },
  { label: 'Mauritania', value: 'MRT' },
  { label: 'Montserrat', value: 'MSR' },
  { label: 'Martinique', value: 'MTQ' },
  { label: 'Mauritius', value: 'MUS' },
  { label: 'Malawi', value: 'MWI' },
  { label: 'Malaysia', value: 'MYS' },
  { label: 'Mayotte', value: 'MYT' },
  { label: 'Namibia', value: 'NAM' },
  { label: 'New Caledonia', value: 'NCL' },
  { label: 'Niger', value: 'NER' },
  { label: 'Norfolk Island', value: 'NFK' },
  { label: 'Nigeria', value: 'NGA' },
  { label: 'Nicaragua', value: 'NIC' },
  { label: 'Niue', value: 'NIU' },
  { label: 'Netherlands, Kingdom of the', value: 'NLD' },
  { label: 'Norway', value: 'NOR' },
  { label: 'Nepal', value: 'NPL' },
  { label: 'Nauru', value: 'NRU' },
  { label: 'New Zealand', value: 'NZL' },
  { label: 'Oman', value: 'OMN' },
  { label: 'Pakistan', value: 'PAK' },
  { label: 'Panama', value: 'PAN' },
  { label: 'Pitcairn', value: 'PCN' },
  { label: 'Peru', value: 'PER' },
  { label: 'Philippines', value: 'PHL' },
  { label: 'Palau', value: 'PLW' },
  { label: 'Papua New Guinea', value: 'PNG' },
  { label: 'Poland', value: 'POL' },
  { label: 'Puerto Rico', value: 'PRI' },
  { label: "Korea, Democratic People's Republic of", value: 'PRK' },
  { label: 'Portugal', value: 'PRT' },
  { label: 'Paraguay', value: 'PRY' },
  { label: 'Palestine, State of', value: 'PSE' },
  { label: 'French Polynesia', value: 'PYF' },
  { label: 'Qatar', value: 'QAT' },
  { label: 'Réunion', value: 'REU' },
  { label: 'Romania', value: 'ROU' },
  { label: 'Russian Federation', value: 'RUS' },
  { label: 'Rwanda', value: 'RWA' },
  { label: 'Saudi Arabia', value: 'SAU' },
  { label: 'Sudan', value: 'SDN' },
  { label: 'Senegal', value: 'SEN' },
  { label: 'Singapore', value: 'SGP' },
  { label: 'South Georgia and the South Sandwich Islands', value: 'SGS' },
  { label: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SHN' },
  { label: 'Svalbard and Jan Mayen', value: 'SJM' },
  { label: 'Solomon Islands', value: 'SLB' },
  { label: 'Sierra Leone', value: 'SLE' },
  { label: 'El Salvador', value: 'SLV' },
  { label: 'San Marino', value: 'SMR' },
  { label: 'Somalia', value: 'SOM' },
  { label: 'Saint Pierre and Miquelon', value: 'SPM' },
  { label: 'Serbia', value: 'SRB' },
  { label: 'South Sudan', value: 'SSD' },
  { label: 'Sao Tome and Principe', value: 'STP' },
  { label: 'Suriname', value: 'SUR' },
  { label: 'Slovakia', value: 'SVK' },
  { label: 'Slovenia', value: 'SVN' },
  { label: 'Sweden', value: 'SWE' },
  { label: 'Eswatini', value: 'SWZ' },
  { label: 'Sint Maarten (Dutch part)', value: 'SXM' },
  { label: 'Seychelles', value: 'SYC' },
  { label: 'Syrian Arab Republic', value: 'SYR' },
  { label: 'Turks and Caicos Islands', value: 'TCA' },
  { label: 'Chad', value: 'TCD' },
  { label: 'Togo', value: 'TGO' },
  { label: 'Thailand', value: 'THA' },
  { label: 'Tajikistan', value: 'TJK' },
  { label: 'Tokelau', value: 'TKL' },
  { label: 'Turkmenistan', value: 'TKM' },
  { label: 'Timor-Leste', value: 'TLS' },
  { label: 'Tonga', value: 'TON' },
  { label: 'Trinidad and Tobago', value: 'TTO' },
  { label: 'Tunisia', value: 'TUN' },
  { label: 'Türkiye', value: 'TUR' },
  { label: 'Tuvalu', value: 'TUV' },
  { label: 'Taiwan, Province of China', value: 'TWN' },
  { label: 'Tanzania, United Republic of', value: 'TZA' },
  { label: 'Uganda', value: 'UGA' },
  { label: 'Ukraine', value: 'UKR' },
  { label: 'United States Minor Outlying Islands', value: 'UMI' },
  { label: 'Uruguay', value: 'URY' },
  { label: 'United States of America', value: 'USA' },
  { label: 'Uzbekistan', value: 'UZB' },
  { label: 'Holy See', value: 'VAT' },
  { label: 'Saint Vincent and the Grenadines', value: 'VCT' },
  { label: 'Venezuela, Bolivarian Republic of', value: 'VEN' },
  { label: 'Virgin Islands (British)', value: 'VGB' },
  { label: 'Virgin Islands (U.S.)', value: 'VIR' },
  { label: 'Vietnam', value: 'VNM' },
  { label: 'Vanuatu', value: 'VUT' },
  { label: 'Wallis and Futuna', value: 'WLF' },
  { label: 'Samoa', value: 'WSM' },
  { label: 'Yemen', value: 'YEM' },
  { label: 'South Africa', value: 'ZAF' },
  { label: 'Zambia', value: 'ZMB' },
  { label: 'Zimbabwe', value: 'ZWE' },
];

export default countryOptions;
